<template>
  <list-layout :tableTools='toggleTableTools'>
    <template slot='header'>
      <BaseHeader :content='header' />
    </template>
    <template slot='table-core'>
      <base-table-pagination
        ref="baseTablePagRef"
        :total='pagination.total'
        :currentPage='pagination.currentPage'
        :perPage='pagination.pageSize'
        @changeCurrentPage='changeCurrentPage'
        @changePerPage='changePerPage'
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-columnas-medatados v-if="hasModuleColumnasDinamicas" @toggleColumnasMetadatosDialog="toggleColumnasMetadatosDialog" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot='table-tags'>
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot='table-component'>
      <kendo-grid-component
        :spanish="spanish"
        :dataResult='kendo.dataResult'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'
        @columnreorder='columnReorder'
        @rowclick='openPath'
        @columnssubmit='onColumnsSubmit'
        @sortchange='sortChange'
        @filterchange='filterChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot='layout-extend'>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="isMoreActionsVisible && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" :ariaHidden="true"/>
                {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot='actions'>
          <div class='mt-5 mb-5'></div>
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading="isGeneralLoading || loader" :disabled="loader"/>
        </template>
      </base-footer>
      <BaseElDialog
          title="Borrar notificación"
          :visible.sync="showModalDelete"
          @open="handleOpenModalDialog('container-handleOpenModal-delete-neo')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-neo">
              <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModalDelete = false}"/>
            </div>
          </template>
      </BaseElDialog>
      <filter-panel :panelOpen='filterPanel' @togglePanel='toggleFilters' @applyFilters='applyFiltersHandler' :status="status"/>
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
      <columnas-panel 
        ref="columnasPanel" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="columnasMetadatosPanel" 
        @togglePanel="toggleColumnasMetadatosDialog" 
        @applyFilters="applyFiltersHandler" />
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/trash/NotificationsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import ColumnasPanel from '@/components/searches/ColumnasPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { getNotifications } from '@/services/notifications/getNotifications'
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
// import { saveExcel } from '@progress/kendo-vue-excel-export'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
// import moment from 'moment'
import { downloadExcel } from '@/services/app/downloadExcel'
import { load } from '@progress/kendo-vue-intl'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import numbers from 'cldr-numbers-full/main/es/numbers.json'
import currencies from 'cldr-numbers-full/main/es/currencies.json'
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import { deleteTrashNEO } from '@/services/trash/deleteTrashNEO'
import { restoreTrashNEO } from '@/services/trash/restoreTrashNEO'
import { TIPOS_ESTADOS_DESCARGA_DOWNLOADED } from '@/config/tipos-estados-descarga-downloaded'

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
)

export default {
  name: 'vista-papelera-notificaciones',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    ColumnasPanel,
    BaseElDialog,
  },
  data: function () {
    return {
      idVista: 25,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      columnasMetadatosPanel: false,
      // All
      estadosDescargaDesconocido: TIPOS_ESTADOS_DESCARGA_DOWNLOADED,
      loader: false,
      spanish: true,
      nextStatus: null,
      header: {
        title: i18n.t('trash.notifications'),
        icon: 'trash',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'trashNotifications',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 900, Descripcion: 'Borrar permanentemente' },
        { IdAccion: 901, Descripcion: 'Restaurar' }
      ],
      status: null,
      showModalDelete: false,
      processMessageDelete: '¿Estás seguro que deseas borrar de forma permanente las notificaciones seleccionadas?',
      selectedAction: null,
      notificationActions: null,
    }
  },
  computed: {
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.kendo.dataResult ? this.kendo.dataResult.data.length : 0
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    selectIcon: function (action) {
      return (action) =>
        action === 900 ? 'trash' 
          : 'restore'
    },
    isMoreActionsVisible: function () {
      return this.getAccionesPosibles && this.getAccionesPosibles.length > 0
    },
    userGroups () {
      return this.$store.getters['auth/user']?.Grupos
    },
    userHasPoolGroup () {
      return this.userGroups
        .some(x => x.idTipo === 1)
    },
    userHasAllPermActions () {
      return this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador' || this.userHasPoolGroup
    },
    getAccionesPosibles () {
      if (this.selected && this.selected.length > 0) {
        if (this.userHasAllPermActions || this.hasAllPropietariosByGroups(this.selected)) {
          return this.listaAcciones
        }
      }
      return []
    },
    prevRoutePath () { return this.prevRoute ? this.prevRoute.path : '/' },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    hasModuleColumnasDinamicas () {
      return this.$store.getters['auth/hasModuleColumnasDinamicas']
    },
  },
  watch: {
    $route (to, from) {
      this.updateOnRouteChange(to, from)
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created: async function () {
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.data = await this.applyFilters()
    // await this.$store.dispatch('app/getNotificationsTypes')
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    hasAllPropietariosByGroups (neos) {
      return neos
        .every(x => this.userGroups
          .some(y => y.idGrupo === x.GrupoPropietario.idGrupo))
    },
    deleteNotification: async function () {
      this.showModalDelete = !this.showModalDelete
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    updateOnRouteChange: async function (to, from) {
      this.status = parseInt(to.meta.status)
      this.$store.commit(this.vuexnamespace + '/setMenuType', this.status)
      // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      // this.$store.commit(this.vuexnamespace + '/resetPaginationInfo')
      this.data = await this.applyFilters()
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.Asunto)

      const filtrosContenido = this.tags.filter(x => x[0] === 'textoLibre')
      let dataFilters = null
      if (filtrosContenido && filtrosContenido.length > 0) {
        dataFilters = { filters: [] }
        dataFilters.filters.push({ type: 'contenido', data: filtrosContenido[0][2] })
      }

      this.$router.push(
        {
          name: 'trash/notifications/details', 
          params: { 
            id: event.dataItem.IDInterno, 
            data: dataFilters,
          } 
        })

      // this.$router.push({ name: 'trash/notifications/details', params: { id: event.dataItem.IDInterno } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loader = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idInterno: data.idInterno ? data.idInterno.value : null,
        // estadoDescarga: (this.status !== undefined && this.status !== null && this.status !== 99999) ? this.status : data.estadoDescargaExtra ? data.estadoDescargaExtra.value : null,
        tipo: data.tipoNotif ? data.tipoNotif.value : null,
        organismo: data.organismo ? data.organismo.value : null,
        asunto: data.asunto ? data.asunto.value : null,
        TicketID: data.ticketId ? data.ticketId.value : null,
        fechaDisposicionDesde: data.fechaDisposicionDesde ? data.fechaDisposicionDesde.value : null,
        fechaDisposicionHasta: data.fechaDisposicionHasta ? data.fechaDisposicionHasta.value : null,
        fechaDescargaDesde: data.fechaDescargaDesde ? data.fechaDescargaDesde.value : null,
        fechaDescargaHasta: data.fechaDescargaHasta ? data.fechaDescargaHasta.value : null,
        fechaFinTramiteDesde: data.fechaFinTramiteDesde ? data.fechaFinTramiteDesde.value : null,
        fechaFinTramiteHasta: data.fechaFinTramiteHasta ? data.fechaFinTramiteHasta.value : null,
        fechaHoraRegistroDesde: data.fechaHoraRegistroDesde ? data.fechaHoraRegistroDesde.value : null,
        fechaHoraRegistroHasta: data.fechaHoraRegistroHasta ? data.fechaHoraRegistroHasta.value : null,
        // codPGN: data.codPGN ? data.codPGN.value : null,
        CIF: data.cif ? data.cif.value : null,
        CIFTitular: data.cifTitular ? data.cifTitular.value : null,
        NombreCIF: data.NombreCIF ? data.NombreCIF.value : null,
        textoLibre: data.textoLibre ? data.textoLibre.value : null,
        email: data.email ? data.email.value: null,
        emailEnviado: data.emailEnviado ? data.emailEnviado.value: null,
        ultimoError: data.ultimoError ? data.ultimoError.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        borrados: true,
        comentarios: data.notas ? data.notas.value : null,
        altaManual: data.altaManual ? data.altaManual.value : null,
        DescargadaAutomaticamente: data.DescargadaAutomaticamente ? data.DescargadaAutomaticamente.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
        soyPropietario: data.soyPropietario ? data.soyPropietario.value : null,
        usuarioResponsable: data.UsuarioResponsable ? data.UsuarioResponsable.value : null,
        agrupacionCIF: data.agrupacionCIF ? data.agrupacionCIF.value : null,
        agrupacionSede: data.agrupacionSede ? data.agrupacionSede.value : null,
        agrupacionOrganismo: data.agrupacionOrganismo ? data.agrupacionOrganismo.value : null,
        CodigoOrganismo: data.CodigoOrganismo ? data.CodigoOrganismo.value : null,
        NombreOrganismo: data.NombreOrganismo ? data.NombreOrganismo.value : null,
        CodigoProvincia: data.CodigoProvincia ? data.CodigoProvincia.value : null,
        NombreProvincia: data.NombreProvincia ? data.NombreProvincia.value : null,

        nombreGrupoPropietarioAnterior: data.nombreGrupoPropietarioAnterior ? data.nombreGrupoPropietarioAnterior.value : null,
        TieneGrupoReparto: data.TieneGrupoReparto ? data.TieneGrupoReparto.value : null,
        nombrePeticion: data.nombrePeticion ? data.nombrePeticion.value : null,
        enviadoPeticion: data.enviadoPeticion ? data.enviadoPeticion.value : null,
      }
      const orders = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: orders.order, grupos: objColumnas }

      // Filtros multiples casos especiales
      const estadosFilter = data.estadoDescargaExtra ? data.estadoDescargaExtra.value : null
      if (Array.isArray(estadosFilter)) {
        payload.estadosDescarga = estadosFilter
      } else {
        params.estadoDescarga = estadosFilter
      }
      const sedesFilter = data.codPGN ? data.codPGN.value : null
      if (Array.isArray(sedesFilter)) {
        payload.codPGNs = sedesFilter
      } else {
        params.codPGN = sedesFilter
      }

      // Filtros objetos
      if (data.metadato1 && data.metadato1.value && data.metadato1.value.campo && data.metadato1.value.valor && data.metadato1.value.operador) {
        payload.metadato1 = {
          campo: data.metadato1.value.campo,
          valor: data.metadato1.value.valor,
          operador: data.metadato1.value.operador,
        }
      }
      if (data.metadato2 && data.metadato2.value && data.metadato2.value.campo && data.metadato2.value.valor && data.metadato2.value.operador) {
        payload.metadato2 = {
          campo: data.metadato2.value.campo,
          valor: data.metadato2.value.valor,
          operador: data.metadato2.value.operador,
        }
      }
      if (data.metadato3 && data.metadato3.value && data.metadato3.value.campo && data.metadato3.value.valor && data.metadato3.value.operador) {
        payload.metadato3 = {
          campo: data.metadato3.value.campo,
          valor: data.metadato3.value.valor,
          operador: data.metadato3.value.operador,
        }
      }
      if (data.metadato4 && data.metadato4.value && data.metadato4.value.campo && data.metadato4.value.valor && data.metadato4.value.operador) {
        payload.metadato4 = {
          campo: data.metadato4.value.campo,
          valor: data.metadato4.value.valor,
          operador: data.metadato4.value.operador,
        }
      }
      if (data.metadato5 && data.metadato5.value && data.metadato5.value.campo && data.metadato5.value.valor && data.metadato5.value.operador) {
        payload.metadato5 = {
          campo: data.metadato5.value.campo,
          valor: data.metadato5.value.valor,
          operador: data.metadato5.value.operador,
        }
      }

      const selectedIDs = this.selected.map(x => x.IDInterno)
      payload.listaIDs = selectedIDs
      try {
        const response = await downloadExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'notificaciones-borradas.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loader = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      const options = {
        columns: columnsState
      }
      this.columnReorder(options)
      // this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandchange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']

      const params = {
        idInterno: data.idInterno ? data.idInterno.value : null,
        // estadoDescarga: (this.status !== undefined && this.status !== null && this.status !== 99999) ? this.status : data.estadoDescargaExtra ? data.estadoDescargaExtra.value : null,
        tipo: data.tipoNotif ? data.tipoNotif.value : null,
        organismo: data.organismo ? data.organismo.value : null,
        asunto: data.asunto ? data.asunto.value : null,
        TicketID: data.ticketId ? data.ticketId.value : null,
        fechaDisposicionDesde: data.fechaDisposicionDesde ? data.fechaDisposicionDesde.value : null,
        fechaDisposicionHasta: data.fechaDisposicionHasta ? data.fechaDisposicionHasta.value : null,
        fechaDescargaDesde: data.fechaDescargaDesde ? data.fechaDescargaDesde.value : null,
        fechaDescargaHasta: data.fechaDescargaHasta ? data.fechaDescargaHasta.value : null,
        fechaFinTramiteDesde: data.fechaFinTramiteDesde ? data.fechaFinTramiteDesde.value : null,
        fechaFinTramiteHasta: data.fechaFinTramiteHasta ? data.fechaFinTramiteHasta.value : null,
        fechaHoraRegistroDesde: data.fechaHoraRegistroDesde ? data.fechaHoraRegistroDesde.value : null,
        fechaHoraRegistroHasta: data.fechaHoraRegistroHasta ? data.fechaHoraRegistroHasta.value : null,
        // codPGN: data.codPGN ? data.codPGN.value : null,
        CIF: data.cif ? data.cif.value : null,
        CIFTitular: data.cifTitular ? data.cifTitular.value : null,
        NombreCIF: data.NombreCIF ? data.NombreCIF.value : null,
        textoLibre: data.textoLibre ? data.textoLibre.value : null,
        email: data.email ? data.email.value: null,
        emailEnviado: data.emailEnviado ? data.emailEnviado.value: null,
        ultimoError: data.ultimoError ? data.ultimoError.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        borrados: true,
        comentarios: data.notas ? data.notas.value : null,
        altaManual: data.altaManual ? data.altaManual.value : null,
        DescargadaAutomaticamente: data.DescargadaAutomaticamente ? data.DescargadaAutomaticamente.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
        soyPropietario: data.soyPropietario ? data.soyPropietario.value : null,
        usuarioResponsable: data.UsuarioResponsable ? data.UsuarioResponsable.value : null,
        agrupacionCIF: data.agrupacionCIF ? data.agrupacionCIF.value : null,
        agrupacionSede: data.agrupacionSede ? data.agrupacionSede.value : null,
        agrupacionOrganismo: data.agrupacionOrganismo ? data.agrupacionOrganismo.value : null,
        CodigoOrganismo: data.CodigoOrganismo ? data.CodigoOrganismo.value : null,
        NombreOrganismo: data.NombreOrganismo ? data.NombreOrganismo.value : null,
        CodigoProvincia: data.CodigoProvincia ? data.CodigoProvincia.value : null,
        NombreProvincia: data.NombreProvincia ? data.NombreProvincia.value : null,

        nombreGrupoPropietarioAnterior: data.nombreGrupoPropietarioAnterior ? data.nombreGrupoPropietarioAnterior.value : null,
        TieneGrupoReparto: data.TieneGrupoReparto ? data.TieneGrupoReparto.value : null,
        nombrePeticion: data.nombrePeticion ? data.nombrePeticion.value : null,
        enviadoPeticion: data.enviadoPeticion ? data.enviadoPeticion.value : null,
      }

      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      // Filtros multiples casos especiales
      const estadosFilter = data.estadoDescargaExtra ? data.estadoDescargaExtra.value : null
      if (Array.isArray(estadosFilter)) {
        obj.estadosDescarga = estadosFilter
      } else {
        params.estadoDescarga = estadosFilter
      }
      const sedesFilter = data.codPGN ? data.codPGN.value : null
      if (Array.isArray(sedesFilter)) {
        obj.codPGNs = sedesFilter
      } else {
        params.codPGN = sedesFilter
      }

      // Filtros objetos
      if (data.metadato1 && data.metadato1.value && data.metadato1.value.campo && data.metadato1.value.valor && data.metadato1.value.operador) {
        obj.metadato1 = {
          campo: data.metadato1.value.campo,
          valor: data.metadato1.value.valor,
          operador: data.metadato1.value.operador,
        }
      }
      if (data.metadato2 && data.metadato2.value && data.metadato2.value.campo && data.metadato2.value.valor && data.metadato2.value.operador) {
        obj.metadato2 = {
          campo: data.metadato2.value.campo,
          valor: data.metadato2.value.valor,
          operador: data.metadato2.value.operador,
        }
      }
      if (data.metadato3 && data.metadato3.value && data.metadato3.value.campo && data.metadato3.value.valor && data.metadato3.value.operador) {
        obj.metadato3 = {
          campo: data.metadato3.value.campo,
          valor: data.metadato3.value.valor,
          operador: data.metadato3.value.operador,
        }
      }
      if (data.metadato4 && data.metadato4.value && data.metadato4.value.campo && data.metadato4.value.valor && data.metadato4.value.operador) {
        obj.metadato4 = {
          campo: data.metadato4.value.campo,
          valor: data.metadato4.value.valor,
          operador: data.metadato4.value.operador,
        }
      }
      if (data.metadato5 && data.metadato5.value && data.metadato5.value.campo && data.metadato5.value.valor && data.metadato5.value.operador) {
        obj.metadato5 = {
          campo: data.metadato5.value.campo,
          valor: data.metadato5.value.valor,
          operador: data.metadato5.value.operador,
        }
      }

      try {
        const data = await this.getItemsData(obj, params)
        if (data) {
          // Cambiar nombre columnas dinamicas
          this.$store.commit('trashNotifications/setkendoColumnsMetadatos', data.metadatosAdicionales)
          // Devolver datos
          return data.data.map(item => {
            item.selected = false
            // item.FechaDisposicion = moment(item.FechaDisposicion).format('DD-MM-yyyy HH:mm')
            const yearFechaDescarga = new Date(item.FechaDescarga).getFullYear()
            item.FechaDescarga = yearFechaDescarga >= 2000 ? item.FechaDescarga : ' - '
            // Formato para fechas dependiendo del tipo de estado
            const tmp = this.estadosDescargaDesconocido
            if (item.FechaDescarga === ' - ' && tmp.includes(item.Estado.Id)) {
              item.FechaDescarga = 'Desconocido'
            }
            const yearFechaFinTramite = new Date(item.FechaFinTramite).getFullYear()
            item.FechaFinTramite = yearFechaFinTramite >= 2000 ? item.FechaFinTramite : ' - '
            return item
          })
        }
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.updateAllSelectedHeader()
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.respuesta
      const metadatosAdicionales = {
        metadato1: res.metadatos.Metadato1,
        metadato2: res.metadatos.Metadato2,
        metadato3: res.metadatos.Metadato3,
        metadato4: res.metadatos.Metadato4,
        metadato5: res.metadatos.Metadato5,
      }

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return { data, metadatosAdicionales }
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getNotifications(orders, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    headerCoreFiltersHandler: async function (obs) {
      if (this.isHeadCoreReady) {
        this.data = await this.applyFilters()
      }
    },
    removeAllTagsHandler: async function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    tableSortByChangeHandler: async function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters()
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsNEOs: []
        }
        for (const element of this.selected) {
          payload.idsNEOs.push(element.IDInterno)
        }
        const response = await deleteTrashNEO(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    restoreNEO: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsNEOs: []
        }
        for (const element of this.selected) {
          payload.idsNEOs.push(element.IDInterno)
        }
        const response = await restoreTrashNEO(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          bus.$emit('changeIt', 'changed menu')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 900) { // borrar
        this.deleteNotification()
      } else if (this.selectedAction.IdAccion === 901) { // recuperar
        this.restoreNEO()
      } else {
        console.error('Acción desconocida')
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    toggleColumnasMetadatosDialog () {
      this.columnasMetadatosPanel = !this.columnasMetadatosPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang='scss' scoped>
</style>
